import React, { useEffect, useState } from "react";
import { images } from "../constants";
import axiosInstance from "../AxiosInstance";

const Wawata = () => {
  const [wawataImages, setWawataImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const response = await axiosInstance.get("/files/page/WAWATA");
        const wawataImages = response.data
          //.filter(photo => photo.page === "WAWATA")
          .sort((a, b) => new Date(b.date) - new Date(a.date));
        setWawataImages(wawataImages);
      } catch (error) {
        console.error("Failed to fetch photos:", error);
      } finally {
        setLoading(false); 
      }
    };

    fetchPhotos();
  }, []);


  return (
    <div className="min-h-screen bg-cover bg-center">
      {/* Header 1 */}
      <header className="w-full min-h-[120px] md:min-h-[150px] border-2 border-blue-600 dark:border-gray-500 flex flex-row flex-nowrap justify-between items-stretch bg-[#85c4de] dark:bg-black/90 backdrop-blur-sm overflow-hidden">
        {/* Left Section */}
        <div className="flex flex-1 items-center justify-center border-r-2 border-blue-600 dark:border-gray-500 p-2 min-w-0">
          <div className="flex flex-col md:flex-row items-center text-center md:text-left w-full overflow-hidden">
            <img
              src={images.visigalogo}
              alt="logo"
              className="h-20 w-20 mb-2 md:mb-0 md:mr-2 flex-shrink-0"
            />
            <h1 className="font-bold text-[0.6rem] sm:text-sm md:text-lg break-words leading-snug text-gray-900 dark:text-gray-100">
              St Mary's Junior Seminary (VISIGA SEMINARY)
            </h1>
          </div>
        </div>

        {/* Center Section */}
        <div className="flex flex-1 justify-center items-center border-r border-blue-600 dark:border-gray-500 p-2 min-w-0">
          <div className="flex flex-col items-center text-center w-full">
            <h2 className="font-bold text-[0.6rem] sm:text-sm md:text-lg break-words leading-snug text-gray-900 dark:text-gray-100">
              WANAWAKE WAKATOLIKI TANZANIA (WAWATA) WA JIMBO KUU LA DAR ES SALAAM
            </h2>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex flex-1 items-center justify-center p-2 min-w-0">
          <div className="flex flex-col md:flex-row items-center text-center md:text-left w-full overflow-hidden">
            <img
              src={images.wawata2}
              alt="arch"
              className="h-20 w-20 mb-2 md:mb-0 md:mr-2 flex-shrink-0"
            />
            <h3 className="font-bold text-[0.6rem] sm:text-sm md:text-lg break-words leading-snug text-gray-900 dark:text-gray-100">
              WANAWAKE WAKATOLIKI TANZANIA (WAWATA)
            </h3>
          </div>
        </div>
      </header>

      {/* Header 2 */}
      <header className="w-full min-h-[120px] md:min-h-[150px] border-2 border-blue-600 dark:border-gray-500 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 justify-start items-stretch bg-[#85c4de] dark:bg-black/90 backdrop-blur-sm overflow-hidden p-2">
        {loading ? (
          <div className="text-gray-700 dark:text-gray-300">Loading...</div>
        ) : wawataImages.length > 0 ? (
          wawataImages.map((image, index) => (
            <div
              key={index}
              className="flex flex-1 min-w-[250px] md:min-w-[300px] items-center justify-center border border-blue-600 dark:border-gray-500 p-2"
            >
              <div className="flex flex-col items-center text-center w-full">
                <img
                  src={image.photoUrl}
                  alt={image.name || "WAWATA"}
                  className="object-contain max-h-[150px] w-full mb-2"
                />
                <h2 className="font-bold text-[0.6rem] sm:text-sm md:text-lg break-words leading-snug text-gray-900 dark:text-gray-100">
                  {image.name}
                </h2>
                <p className="text-xs sm:text-sm md:text-base mt-1 text-gray-700 dark:text-gray-300">
                  {image.description}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="text-gray-700 dark:text-gray-300">No WAWATA Images Found</div>
        )}
      </header>
    </div>
  );
};

export default Wawata;
